<template>
  <div class="order-confirm-back-dialog">
    <el-dialog
      v-model="visible"
      :show-close="false"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      top="50%"
    >
      <div class="dialog-body">
        <img class="top-img" src="https://o.666visa.cn/static/ssqpeer/order/confirm/order-confirm-back-dialog-top-pc.png" />
        <div class="dialog-header">
          <div class="header-title">您离成功办签还差一步！</div>
          <div></div>
        </div>
        <div class="dialog-content">
          现在预订并提交资料，<span class="date">{{date}}</span>即可出发。确定要离开吗？
        </div>
        <div class="dialog-footer">
          <div class="info-btn" @click="onConfirm">确认离开</div>
          <div class="primary-btn" @click="onClose">再想想</div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import sensorsdata from 'sa-sdk-javascript';

export default {
  name: 'pay-ensure-modal',
  data() {
    return {
      visible: false,
      date: '',
      resolve: null,
      reject: null,
    };
  },
  computed: {},
  watch: {
    visible() {
      if (!this.visible) {
        setTimeout(() => {
          this.handleAfterLeave();
        }, 300);
      }
    },
  },
  created() {
    sensorsdata.track('PopWindowExpose', {
      page_from: '订单确认页',
      activity_name: '支付退出拦截',
    });
  },
  methods: {
    handleAfterLeave() {
      this.$destroy(true);
      this.$el.parentNode.removeChild(this.$el);
    },

    // 点击确认
    orderSubmitAndPay() {
      this.$emit('ensure');
    },
    onConfirm() {
      sensorsdata.track('PopWindowClick', {
        page_from: '订单确认页',
        activity_name: '支付退出拦截',
        button_name: '确认离开',
      });
      this.visible = false;
      this.resolve && this.resolve();
    },
    onClose() {
      sensorsdata.track('PopWindowClick', {
        page_from: '订单确认页',
        activity_name: '支付退出拦截',
        button_name: '继续预定',
      });
      this.visible = false;
      this.reject && this.reject();
    },
  },

};
</script>

<style lang="less" scoped>
.order-confirm-back-dialog{
  /deep/ .el-dialog__wrapper{
    .el-dialog {
      width: 400px;
      top: 50%;
      transform: translate(-50%, -50%);
      background: transparent;
    }
    .el-dialog__header {
      display: none;
    }
    .el-dialog__body {
      padding: 0;
    }
  }
  .dialog-body{
    background: linear-gradient(180deg, #E6F1FF 0%, #FFFFFF 55%, #FFFFFF 100%);
    padding: 32px;
    line-height: 1;
    border-radius:4px;
    position: relative;
    .top-img{
      position: absolute;
      bottom: 100%;
      left: 50%;
      transform: translateX(-50%);
      width: 224px;
      height: 97px;
    }
    .dialog-header{
      color: #2F333D;
      font-size: 20px;
      line-height: 28px;
      font-weight: 600;
      text-align: center;
    }
    .dialog-content{
      margin-top: 8px;
      color: #2F333D;
      font-size: 16px;
      line-height: 24px;
      text-align: center;
      .date{
        color: #F43344;
      }
    }

    .dialog-footer{
      margin-top: 32px;
      display: flex;
      align-items: center;
      justify-content: center;
      .info-btn, .primary-btn{
        width: 120px;
        height: 48px;
        background: #F3F6F9;
        border-radius: 4px;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #2F333D;
        font-size: 18px;
        cursor: pointer;
      }
      .primary-btn{
        background: #599FFF;
        color: #fff;
        margin-left: 16px;
      }
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/pages/ordering/components/order-confirm-back-dialog/order-confirm-back-dialog.vue